import { normalizeDate } from "../../../../../components/common/Converter";
import { parseSchedPatternFromLog } from "../utils/utils";
export const _getDaysDeducted = async (
  params,
  absentDateByEmployee,
  halfDateByEmployee,
  absentByEmployeeAirport
) => {
  const {
    objects,
    dateRanges,
    completeLogs,
    manualDtrSet,
    leaveSetByEmployee,
    holidaySet,
    suspensionSet,
    schedPatternByEmployee,
    manualDtrSetByEmployee,
    airportAbsentSet,
    isArrayDate,
    assignmentPeriodByEmployee,
    hasForcedOrSpecial,
    isAp,
  } = params;

  console.log("leaveSetByEmployee", leaveSetByEmployee);

  //employee's Logs
  const storedLogs = {};
  for (const log of completeLogs) {
    const empId = log?.employee?.id;

    if (empId) {
      if (!storedLogs[empId]) {
        storedLogs[empId] = [];
      }
      storedLogs[empId].push(log);
    }
  }

  let result = [];
  for (const employee of objects) {
    const employeeId = employee.id;

    if (assignmentPeriodByEmployee && !assignmentPeriodByEmployee[employeeId]) {
      result.push({
        employeeId,
        totalAbsences: isArrayDate ? Array(dateRanges.length).fill(0) : 0,
        totalWorkingDays: isArrayDate ? Array(dateRanges.length).fill(0) : 0,
      });
      continue;
    }

    const startingDate = new Date(employee?.selectedSchedule?.startingDate);
    const logs = storedLogs[employeeId] || [];
    const schedPattern = schedPatternByEmployee?.[employeeId] || {};

    const dateOfAbsent = absentDateByEmployee[employeeId];
    const dateOfAbsentAirport = absentByEmployeeAirport?.[employeeId];
    const manualDtrOfEmployee =
      manualDtrSetByEmployee?.[employeeId] || new Set();
    const twentyFourSeven = ["12", "9"].some((prefix) =>
      employee?.twentyFourSeven?.startsWith(prefix)
    );

    console.log("manualDtrOfEmployee", manualDtrOfEmployee);

    const logSet = new Set();
    logs.forEach((log) => {
      const logDate = new Date(log.date).toDateString();
      logSet.add(logDate);
    });

    if (dateOfAbsent) {
      for (const dateStr of dateOfAbsent) {
        logSet.delete(dateStr);
      }
    }

    if (dateOfAbsentAirport instanceof Set) {
      for (const date of dateOfAbsentAirport) {
        logSet.delete(date);
      }
    }

    let totalAbsences = isArrayDate ? [] : 0;
    let totalWorkingDays = isArrayDate ? [] : 0;
    let workingDates = [];
    const dateOfAbsences = {};

    for (const range of dateRanges) {
      let start = new Date(range?.startDate);
      let end = new Date(range?.endDate);

      const airportSched = assignmentPeriodByEmployee?.[employeeId];
      if (airportSched) {
        if (start < airportSched.start) start = new Date(airportSched.start);
        if (end > airportSched.end) end = new Date(airportSched.end);
      }

      const groupLogsByDynamicSchedule = (logs = [], dateRanges = []) => {
        if (!logs.length && !dateRanges.length) return {};

        // 🧩 Sort logs chronologically
        logs.sort((a, b) => new Date(a.date) - new Date(b.date));

        const formatDate = (date) => {
          const d = new Date(date);
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const day = String(d.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        const result = {};

        // ✅ Determine final selection start/end (handle unordered dateRanges)
        let rangeStart, rangeEnd;

        if (dateRanges.length) {
          // 🧠 Sort the dateRanges by startDate
          const sortedRanges = [...dateRanges].sort(
            (a, b) => new Date(a.startDate) - new Date(b.startDate)
          );

          const firstStart = new Date(sortedRanges[0].startDate);
          const lastEnd = new Date(
            sortedRanges[sortedRanges.length - 1].endDate
          );
          const today = new Date();

          // Cap lastEnd to today if it exceeds current date
          rangeStart = firstStart;
          rangeEnd = lastEnd > today ? today : lastEnd;
        } else {
          // fallback to logs only
          rangeStart = new Date(logs[0].date);
          rangeEnd = new Date(logs[logs.length - 1].date);
        }

        // ✅ Filter logs within the date range
        const filteredLogs = logs.filter((log) => {
          const logDate = new Date(log.date);
          return logDate >= rangeStart && logDate <= rangeEnd;
        });

        if (!filteredLogs.length) return {};

        // ✅ Group by schedule pattern (your original logic)
        let currentGroupStart = filteredLogs[0].date;
        let prevParsed = parseSchedPatternFromLog(filteredLogs[0]) || {};
        let prevKey = Object.keys(prevParsed)[0];
        let prevValue = JSON.stringify(prevParsed[prevKey] || []);
        let currentGroupLogs = [filteredLogs[0]];
        const tempGroups = [];

        for (let i = 1; i < filteredLogs.length; i++) {
          const currentLog = filteredLogs[i];
          const parsed = parseSchedPatternFromLog(currentLog) || {};
          const currentKey = Object.keys(parsed)[0];
          const currentValue = JSON.stringify(parsed[currentKey] || []);

          const isSameSchedule =
            currentKey === prevKey && currentValue === prevValue;

          if (!isSameSchedule) {
            tempGroups.push({
              start: currentGroupStart,
              end: filteredLogs[i - 1].date,
              parsed: prevParsed,
              logs: currentGroupLogs,
            });
            currentGroupStart = currentLog.date;
            prevParsed = parsed;
            prevKey = currentKey;
            prevValue = currentValue;
            currentGroupLogs = [currentLog];
          } else {
            currentGroupLogs.push(currentLog);
          }
        }

        // push last group
        tempGroups.push({
          start: currentGroupStart,
          end: filteredLogs[filteredLogs.length - 1].date,
          parsed: prevParsed,
          logs: currentGroupLogs,
        });

        // ✅ Extend first & last groups to cover full selected range
        if (tempGroups.length) {
          tempGroups[0].start = rangeStart;
          tempGroups[tempGroups.length - 1].end = rangeEnd;
        }

        // ✅ Build final result
        for (const group of tempGroups) {
          const validStartingDates = group.logs
            .map((log) => log.schedule?.startingDate)
            .filter(Boolean)
            .sort();

          const startingDate = validStartingDates[0];
          const rangeKey = `${formatDate(group.start)} - ${formatDate(
            group.end
          )}`;
          result[rangeKey] = {
            ...group.parsed,
            ...(startingDate && { startingDate }),
          };
        }

        return result;
      };

      const groupLogsDate = groupLogsByDynamicSchedule(logs, dateRanges);

      // const schedStart = normalizeDate(startingDate);
      // if (start < schedStart) start = schedStart;

      const allWorkingDates = _getWorkingDaysList(
        start,
        end,
        // schedPattern,
        // schedStart
        groupLogsDate
      );

      // console.log("allWorkingDates", allWorkingDates);

      const actualWorkingDays = allWorkingDates.filter((dateStr) => {
        const skipSuspension = twentyFourSeven || !suspensionSet.has(dateStr);

        return (
          // !holidaySet.has(dateStr) &&
          // skipSuspension &&
          !logSet.has(dateStr) &&
          (isAp
            ? !hasForcedOrSpecial &&
              !leaveSetByEmployee[employeeId]?.has(dateStr)
            : !leaveSetByEmployee[employeeId]?.has(dateStr))
          // !airportDutyByEmployee.has(dateStr)
        );
      });

      // console.log("actualWorkingDays", actualWorkingDays);

      if (isArrayDate) {
        totalAbsences.push(actualWorkingDays.length);
        totalWorkingDays.push(allWorkingDates.length);
        workingDates.push(allWorkingDates);
        if (!dateOfAbsences[employeeId]) {
          dateOfAbsences[employeeId] = [];
        }
        const dateSet = new Set();
        actualWorkingDays.forEach((d) => dateSet.add(d));
        dateOfAbsences[employeeId].push(dateSet);
      } else {
        totalAbsences += actualWorkingDays.length;
        totalWorkingDays = allWorkingDates.length;
        workingDates = allWorkingDates;
        if (!dateOfAbsences[employeeId]) {
          dateOfAbsences[employeeId] = new Set();
        }
        actualWorkingDays.forEach((d) => dateOfAbsences[employeeId].add(d));
      }
    }

    if (isArrayDate) {
      totalAbsences = totalAbsences.map((val) => Math.min(val, 22));
    } else {
      totalAbsences = Math.min(totalAbsences, 22);
    }

    result.push({
      employeeId,
      totalAbsences,
      totalWorkingDays,
      workingDates,
      dateOfAbsences,
    });
  }

  return result;
};
const _getWorkingDaysList = (rangeStart, rangeEnd, groupLogsSched) => {
  const start = new Date(rangeStart);
  const end = new Date(rangeEnd);
  const result = [];

  const formatDate = (date) => new Date(date).toISOString().split("T")[0];

  // Reusable checks
  const isWeekday = (date, schedPattern) => {
    if (!schedPattern?.selectedOption) return false;
    const dayName = date.toLocaleString("en-US", { weekday: "long" });
    const bool = schedPattern?.selectedOption.some(
      (sched) => sched.day === dayName
    );

    return bool;
  };

  const isInCycle = (date, schedPattern) => {
    if (!schedPattern?.matchedSchedule || !schedPattern?.startingDate)
      return false;

    const [_, work, off] = schedPattern.matchedSchedule.map(Number);
    const cycleLength = work + off;
    const startingDate = new Date(schedPattern?.startingDate);
    startingDate.setHours(0, 0, 0, 0);

    const daysFromStart = Math.floor(
      (date - startingDate) / (1000 * 60 * 60 * 24)
    );

    const cycleDay =
      ((daysFromStart % cycleLength) + cycleLength) % cycleLength;
    return cycleDay < work;
  };

  const isInGraveyardList = (date, schedPattern) => {
    if (!schedPattern?.twoDayGraveyardMatchList) return false;
    const dayName = date.toLocaleString("en-US", { weekday: "long" });
    return schedPattern.twoDayGraveyardMatchList.some(
      ({ match }) => match[1] === dayName || match[2] === dayName
    );
  };

  const isInAltWorkingDays = (date, schedPattern) => {
    if (!schedPattern?.workingDaysAlt) return false;
    const dayName = date.toLocaleString("en-US", { weekday: "long" });
    return schedPattern.workingDaysAlt.includes(dayName);
  };

  const isWorkingDay = (date, schedPattern) => {
    if (schedPattern?.selectedOption) return isWeekday(date, schedPattern);
    if (schedPattern?.matchedSchedule && schedPattern?.startingDate)
      return isInCycle(date, schedPattern);
    if (schedPattern?.twoDayGraveyardMatchList)
      return isInGraveyardList(date, schedPattern);
    if (schedPattern?.workingDaysAlt)
      return isInAltWorkingDays(date, schedPattern);
    return false;
  };

  const getScheduleForDate = (current, groupLogsSched) => {
    for (const range in groupLogsSched) {
      const [startStr, endStr] = range.split(" - ");
      const start = new Date(startStr);
      const end = new Date(endStr);

      start.setHours(0, 0, 0, 0);
      end.setHours(0, 0, 0, 0);
      current.setHours(0, 0, 0, 0);

      if (current >= start && current <= end) {
        return groupLogsSched[range];
      }
    }

    return null; // not found
  };

  let current = new Date(start);
  while (current <= end) {
    const schedPattern = getScheduleForDate(current, groupLogsSched);

    if (schedPattern && isWorkingDay(current, schedPattern)) {
      result.push(current.toDateString());
    }
    current.setDate(current.getDate() + 1);
  }

  return result;
};
